import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'gallery-section';
const BLOCK_ID = 'gallery-section';
const PLACEHOLDER_LABEL = 'Galerie Section';

export default function gallerySection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-gallery-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Gallery Section',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-gallery',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'checkbox',
                        name: 'showPreview',
                        label: 'Vorschau anzeigen',
                        valueTrue: true,
                        valueFalse: false,
                        default: true,
                    },
                ],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Galerie Section',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2ZM5 5h14v14H5V5Zm2 10 2.5-3 2 2.5 2.5-3L19 17H5l2-2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-gallery',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
